import BnccExamSessionsTableContainer from "home/components/bncc_exam/containers/sessions_table_container"
import BnccExamPerformanceByAreaChartContainer from "home/components/bncc_exam/containers/performance_by_area_chart_container"

export { BnccExamSessionsTableContainer, BnccExamPerformanceByAreaChartContainer }
